/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export function isField(selection) {
    return selection.kind === "Field";
}
//# sourceMappingURL=isField.js.map
